// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const convertHexColorToUrlSVGColor = (color?: any) => {
  if (color && typeof color === 'string') {
    return color.replace('#', '%23');
  } else {
    return color;
  }
};
